import React, { useEffect, useState } from 'react';
import { Button, Loading } from 'carbon-components-react';
import { v2BaseUrl } from '../../utils/config';
import callApi from '../../actions/callApi';
import { useParams } from 'react-router-dom';
import { xapi } from '../../utils/xapi';
import NoContentBox from '../../components/common/NoContentBox';
import { getCurrEnvironment } from './../common/common';

const getPSBriefingDeckDoc = (selectionYear) => {
  const url = `${v2BaseUrl}/commonHelper/file/ps-briefing-deck?selectionYear=${selectionYear}`;
  const params = {
    url,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return xapi(params);
};

const PSBriefingDeck = (props) => {
  const { appId, jobId } = useParams();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showLoader, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState(null);
  const uid = `${appId}-${jobId}`;
  const { selectionYear } = props || {};

  const getDocData = async () => {
    if (!jobId) return;
    setLoading(true);

    await getPSBriefingDeckDoc(jobId)
      .then((resp) => {
        const { url, error } = resp ?? {};
        if (resp && !error && url) {
          setPdfUrl(url);
        } else setErrMsg(error?.message || 'Error fetching document');
      })
      .catch((err) => {
        console.error(err);
      });
    setLoading(false);
  };

  useEffect(() => {
    getDocData();
  }, []);

  const currEnv = getCurrEnvironment();
  const DOMAIN_URL =
    currEnv == 'production'
      ? 'https://ars.csc.gov.sg/'
      : 'https://cscstag.csc.gov.sg/';
  const PDF_URL = `${DOMAIN_URL}/roboroy/api/v2/commonHelper/file/ps-briefing-deck?selectionYear=${selectionYear}&passAsStream=1`;

  return (
    <div className="x-doc-outer-con">
      {showLoader !== true && (
        <>
          {pdfUrl ? (
            // <div id={`x-doc-wrapper-${uid}`}>
            //   <iframe
            //     style={{ height: '90vh' }}
            //     src={pdfUrl}
            //     height="100%"
            //     width="100%"
            //   />
            // </div>
            <div
              id={`x-doc-wrapper-${uid}`}
              className="tw-relative tw-w-full"
              style={{ height: '90vh' }}>
              <iframe
                title="PDF Viewer"
                // src={pdfUrl}
                src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
                  PDF_URL
                )}`}
                className="tw-w-full tw-h-full tw-border-0"
                style={{
                  display: 'block',
                  width: '100%',
                  height: '100%',
                  overflow: 'auto',
                  WebkitOverflowScrolling: 'touch', // iOS momentum scroll
                  transform: 'translateZ(0)', // GPU acceleration
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                scrolling="yes"></iframe>
            </div>
          ) : (
            <NoContentBox message={errMsg} />
          )}
        </>
      )}
      {showLoader === true && (
        <div className="bx--row justify-content-around">
          <Loading withOverlay={false} />
        </div>
      )}
    </div>
  );
};

export default PSBriefingDeck;
